export default {
    en: {
        id: 'diagram4b2-3',
        blocks: [
            {
                index: '1',
                task: 'S = A few decades ago pensions were taken for granted by all',
                title: "S = "
            },
            {
                index: '2',
                task: 'C = Today pensions are almost dead in corporate America',
                title: "C = "
            },
            {
                index: '3',
                task: 'Q = Who killed them?',
                title: "Q = "
            }
        ],
        answers: [
            {
                index: '2',
                title: 'Not any more'
            },
            {
                index: '3',
                title: 'Why not?'
            },
            {
                index: '1',
                title: 'X used to be common'
            },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3,
        note: 'This one is interesting, in that it includes the Answer in the Question, hints at the structure of the document with a second question, and puts both at the beginning for more dramatic effect. You can of course change the order of an introduction’s parts and still be clear, so long as you maintain their structural relationship. And while this approach may make for a strong introduction, it leaves you limited in enabling you to talk about a solution to the problem.'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise3.js